(() => {
  const ready = (cb) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', cb, { once: true });
    } else {
      cb();
    }
  };

  ready(() => {
    // Tabs
    document.querySelectorAll('[data-polaris-tabs]').forEach((tabsEl) => {
      const tabs = tabsEl.querySelectorAll('[data-polaris-tab]');
      const panels = tabsEl.querySelectorAll('[data-polaris-panel]');

      const activate = (id) => {
        tabs.forEach((tab) => {
          const isActive = tab.dataset.polarisTab === id;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive);
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
        });
        panels.forEach((panel) => {
          const isActive = panel.dataset.polarisPanel === id;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => activate(tab.dataset.polarisTab));
        tab.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            activate(tab.dataset.polarisTab);
          }
        });
      });

      // Initialize first tab if none active
      const current = Array.from(tabs).find((t) => t.classList.contains('is-active')) || tabs[0];
      if (current) activate(current.dataset.polarisTab);
    });

    // Dismissible banners
    document.querySelectorAll('[data-polaris-banner-dismiss]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const banner = btn.closest('.Polaris-Banner');
        if (banner) banner.remove();
      });
    });

    // Toasts
    const toastContainer = document.querySelector('[data-polaris-toast-container]');
    document.querySelectorAll('[data-polaris-toast-trigger]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!toastContainer) return;
        const toast = document.createElement('div');
        toast.className = 'Polaris-Toast';
        toast.innerHTML = `
          <span>${btn.dataset.polarisToastTrigger || 'Saved'}</span>
          <button class="Polaris-Toast__Dismiss" aria-label="Dismiss">&times;</button>
        `;
        toastContainer.appendChild(toast);

        const remove = () => toast.remove();
        toast.querySelector('.Polaris-Toast__Dismiss').addEventListener('click', remove);
        setTimeout(remove, 3500);
      });
    });

    // Mobile nav toggle
    const nav = document.querySelector('[data-polaris-nav]');
    const navToggle = document.querySelector('[data-polaris-nav-toggle]');
    if (nav && navToggle) {
      navToggle.addEventListener('click', () => {
        const isOpen = nav.classList.toggle('is-open');
        navToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }
  });
})();
